// extracted by mini-css-extract-plugin
export default {"root":"root-KHdG9f","back":"back-lVv9j6","icon":"icon-crs8Wp","active":"active-_fh_fR","text":"text-lePCra"};